import { Component, Input } from '@angular/core';
import { NotifsAndMessagesService } from './notifs-and-messages.service';

@Component({
  selector: 'app-notificatoins-and-messages-dropdown',
  templateUrl: './notificatoins-and-messages-dropdown.component.html',
  styleUrls: ['./notificatoins-and-messages-dropdown.component.css'],
  standalone: false,
})
export class NotificatoinsAndMessagesDropdownComponent {
  @Input() notifications: any;
  @Input() messages: any;

  constructor(private notifsService: NotifsAndMessagesService) {}
  ngOnInit() {}

  get unseenNotifCount() {
    return this.notifications.extra.unseen_notifications_count;
  }

  get sortedNotifications() {
    // not seen notifs first then by date
    return this.notifications.results.slice().sort((a, b) => {
      if (!a.seen && b.seen) return -1; // a is unseen, b is seen
      if (a.seen && !b.seen) return 1; // a is seen, b is unseen
      return (
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      ); // both seen or unseen, sort by date
    });
  }

  get unseenMessageCount() {
    return this.messages.extra.unseen_messages_count;
  }

  get sortedMessages() {
    // not seen messages first then by date
    return this.messages.results.slice().sort((a, b) => {
      if (!a.seen && b.seen) return -1; // a is unseen, b is seen
      if (a.seen && !b.seen) return 1; // a is seen, b is unseen
      return (
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      ); // both seen or unseen, sort by date
    });
  }

  async markNotificationSeen(notif) {
    await this.notifsService.markNotificationAsSeen(notif.id);
    notif.seen = true;
    this.notifications.extra.unseen_notifications_count--;
  }

  async deleteNotification(notif) {
    await this.notifsService.deleteNotification(notif.id);
    this.notifications.results = this.notifications.results.filter(
      (e) => e.id !== notif.id,
    );
    this.notifications.count--;
    if (!notif.seen) this.notifications.extra.unseen_notifications_count--;
  }

  deleteAllNotifications() {
    const lastFetchedId = this.notifications.results.length
      ? this.notifications.results[0].id
      : 0;
    this.notifsService.deleteAllNotifications(lastFetchedId).then(() => {
      this.notifications.results = [];
      this.notifications.count = 0;
    });
    this.notifications.extra.unseen_notifications_count = 0;
  }
  seeAllNotifications() {
    const lastFetchedId = this.notifications.results.length
      ? this.notifications.results[0].id
      : 0;
    this.notifsService.seeAllNotifications(lastFetchedId).then(() => {
      this.notifications.results.forEach((notif) => (notif.seen = true));
    });
    this.notifications.extra.unseen_notifications_count = 0;
  }

  async openNotification(notif) {
    if (!notif.seen) await this.markNotificationSeen(notif);
    switch (notif.action_type) {
      case 2:
        // Open a link
        switch (notif.action_data.item_type) {
          case 0:
            window.open('workshop/workshops', '_self');
            break;
          case 1:
            window.open('e-workshop/e-workshops', '_self');
            break;
          case 2:
            window.open('profile/my-training-history', '_self');
            break;
          case 3:
            window.open(
              'e-workshop/e-workshops/' + notif.action_data.item_id,
              '_self',
            );
        }
    }
    console.log('Opening notification:', notif);
  }

  async markMessageAsSeen(message) {
    await this.notifsService.markMessageAsSeen(message.id);
    message.seen = true;
    this.messages.extra.unseen_messages_count--;
  }

  deleteMessage(message) {
    this.notifsService.deleteMessage(message.id).then(() => {
      this.messages.results = this.messages.results.filter(
        (e) => e.id !== message.id,
      );
      this.messages.count--;
      if (!message.seen) this.messages.extra.unseen_messages_count--;
    });
  }

  deleteAllMessages() {
    const lastFetchedId = this.messages.results.length
      ? this.messages.results[0].id
      : 0;
    this.notifsService.deleteAllMessages(lastFetchedId).then(() => {
      this.messages.results = [];
      this.messages.count = 0;
    });
    this.messages.extra.unseen_messages_count = 0;
  }

  seeAllMessages() {
    const lastFetchedId = this.messages.results.length
      ? this.messages.results[0].id
      : 0;
    this.notifsService.seeAllMessages(lastFetchedId).then(() => {
      this.messages.results.forEach((message) => (message.seen = true));
    });
    this.messages.extra.unseen_messages_count = 0;
  }

  async openMessage(message) {
    if (!message.seen) await this.markMessageAsSeen(message);
    window.open(`message/${message.id}`, '_self');
  }

  notifsPage = 1;
  hasNextNotifPage = true;
  onNotifsScroll() {
    if (!this.hasNextNotifPage) return;
    this.notifsService
      .getNotifications(this.notifsPage + 1, this.notifications.results[0]?.id)
      .subscribe((data: any) => {
        if (data.results.length > 0) {
          this.notifications.results.push(...data.results);
          this.notifsPage++;
          this.hasNextNotifPage = Boolean(data.next?.length);
        }
      });
  }
  messagesPage = 1;
  hasNextMessagePage = true;
  onMessagesScroll() {
    if (!this.hasNextMessagePage) return;
    this.notifsService
      .getMessages(this.messagesPage + 1, this.messages.results[0]?.id)
      .subscribe((data: any) => {
        if (data.results.length > 0) {
          this.messages.results.push(...data.results);
          this.messagesPage++;
          this.hasNextMessagePage = Boolean(data.next?.length);
        }
      });
  }
}
/**
@ROOT = {{baseUrl}}
@auth_token = {{auth_token}}
###
GET {{ROOT}}/notifications/
Authorization: Bearer {{auth_token}}

###
GET {{ROOT}}/notifications/updates/1/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/notifications/delete/1002/
Authorization: Bearer {{auth_token}}

###
DELETE {{ROOT}}/notifications/delete-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 1008
}

###
PATCH {{ROOT}}/notifications/see/1006/
Authorization: Bearer {{auth_token}}


###
PATCH {{ROOT}}/notifications/see-all/
Authorization: Bearer {{auth_token}}
Content-Type: application/json

{
    "last_fetched_id": 1008
}
*/
